import { AddressLookupQuestion } from "./AddressLookupQuestion";
import { AnnualTurnoverQuestion } from "./AnnualTurnoverQuestion";
import { DateInputQuestion } from "./DateInputQuestion";
import { DateQuestion } from "./DateQuestion";
import { InfoQuestion } from "./InfoQuestion";
import { MultiSelectQuestion } from "./MultiSelectQuestion/MultiSelectQuestion";
import { NumberQuestion } from "./NumberQuestion";
import {
  PercentageQuestion,
  PercentageGroupQuestion,
} from "./PercentageQuestion";
import { RadioButtonsQuestion } from "./RadioButtonsQuestion";
import { SelectQuestion } from "./SelectQuestion/SelectQuestion";
import { TelephoneQuestion } from "./TelephoneQuestion";
import { TextQuestion } from "./TextQuestion";
import { TradeQuestion } from "./TradeQuestion";
import { AddressLookupGroupQuestion } from "./AddressLookupQuestion/AddressLookupGroupQuestion";
import { CurrencyQuestion } from "./CurrencyQuestion";
import { ZipCodeQuestion } from "./ZipCodeQuestion";
import { USStateQuestion } from "./USStateQuestion";
import { PersonalisedCoverQuestion } from "./PersonalisedCoverQuestion/PersonalisedCoverQuestion";
import { AgreementQuestion } from "./AgreementQuestion";

export const TRIGGERS = {
  CHANGE: "change",
  BLUR: "blur",
} as const;

export const ELEMENT_TYPES = {
  LABEL: "label",
  SPAN: "span",
} as const;

export const questionMap = {
  default: {
    component: TextQuestion,
    trigger: TRIGGERS.BLUR,
    labelElementType: ELEMENT_TYPES.LABEL,
  },
  info: {
    component: InfoQuestion,
    trigger: TRIGGERS.BLUR,
    labelElementType: ELEMENT_TYPES.SPAN,
  },
  address_lookup: {
    component: AddressLookupQuestion,
    trigger: TRIGGERS.CHANGE,
    labelElementType: ELEMENT_TYPES.SPAN,
  },
  address_lookup_group: {
    component: AddressLookupGroupQuestion,
    trigger: TRIGGERS.CHANGE,
    labelElementType: ELEMENT_TYPES.SPAN,
  },
  annual_turnover: {
    component: AnnualTurnoverQuestion,
    trigger: TRIGGERS.BLUR,
    labelElementType: ELEMENT_TYPES.SPAN,
  },
  multiselect: {
    component: MultiSelectQuestion,
    trigger: TRIGGERS.CHANGE,
    labelElementType: ELEMENT_TYPES.SPAN,
  },
  radio_buttons: {
    component: RadioButtonsQuestion,
    trigger: TRIGGERS.CHANGE,
    labelElementType: ELEMENT_TYPES.SPAN,
  },
  select: {
    component: SelectQuestion,
    trigger: TRIGGERS.CHANGE,
    labelElementType: ELEMENT_TYPES.LABEL,
  },
  text: {
    component: TextQuestion,
    trigger: TRIGGERS.BLUR,
    labelElementType: ELEMENT_TYPES.LABEL,
  },
  number: {
    component: NumberQuestion,
    trigger: TRIGGERS.BLUR,
    labelElementType: ELEMENT_TYPES.LABEL,
  },
  currency: {
    component: CurrencyQuestion,
    trigger: TRIGGERS.BLUR,
    labelElementType: ELEMENT_TYPES.LABEL,
  },
  tel: {
    component: TelephoneQuestion,
    trigger: TRIGGERS.BLUR,
    labelElementType: ELEMENT_TYPES.LABEL,
  },
  rebuild_cost_estimate: {
    component: NumberQuestion,
    trigger: TRIGGERS.CHANGE,
    labelElementType: ELEMENT_TYPES.LABEL,
  },
  datepicker: {
    component: DateQuestion,
    trigger: TRIGGERS.CHANGE,
    labelElementType: ELEMENT_TYPES.LABEL,
  },
  date: {
    component: DateInputQuestion,
    trigger: TRIGGERS.BLUR,
    labelElementType: ELEMENT_TYPES.LABEL,
  },
  trade_search: {
    component: TradeQuestion,
    trigger: TRIGGERS.CHANGE,
    labelElementType: ELEMENT_TYPES.SPAN,
  },
  trade_search_ai: {
    component: TradeQuestion,
    trigger: TRIGGERS.CHANGE,
    labelElementType: ELEMENT_TYPES.SPAN,
  },
  personalised_cover: {
    component: PersonalisedCoverQuestion,
    trigger: TRIGGERS.CHANGE,
    labelElementType: ELEMENT_TYPES.LABEL,
  },
  // Items below need to be reconciled
  given_name: {
    component: TextQuestion,
    trigger: TRIGGERS.BLUR,
    labelElementType: ELEMENT_TYPES.LABEL,
  },
  family_name: {
    component: TextQuestion,
    trigger: TRIGGERS.BLUR,
    labelElementType: ELEMENT_TYPES.LABEL,
  },
  email: {
    component: TextQuestion,
    trigger: TRIGGERS.BLUR,
    labelElementType: ELEMENT_TYPES.LABEL,
  },
  percentage_split: {
    component: PercentageQuestion,
    trigger: TRIGGERS.BLUR,
    labelElementType: ELEMENT_TYPES.LABEL,
  },
  percentage_split_group: {
    component: PercentageGroupQuestion,
    trigger: TRIGGERS.BLUR,
    labelElementType: ELEMENT_TYPES.LABEL,
  },
  postcode: {
    component: TextQuestion,
    trigger: TRIGGERS.BLUR,
    labelElementType: ELEMENT_TYPES.LABEL,
  },
  zipcode: {
    component: ZipCodeQuestion,
    trigger: TRIGGERS.BLUR,
    labelElementType: ELEMENT_TYPES.LABEL,
  },
  us_state_select: {
    component: USStateQuestion,
    trigger: TRIGGERS.CHANGE,
    labelElementType: ELEMENT_TYPES.LABEL,
  },
  agreement: {
    component: AgreementQuestion,
    trigger: TRIGGERS.CHANGE,
    labelElementType: ELEMENT_TYPES.SPAN,
  },
};
